export default __webpack_public_path__ + "78c36f1e383de1fb8fdfe66d15e8417d.svg";